import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class JobQuotationService {

  // 固定参数
  private uri = 'plan/api/business/jobQuotation';

  private traceUri = 'plan/api/business/jobQuotationTrace';

  constructor(
    protected httpClient: HttpClient
  ) { }

  // 根据工单ID获取报价
  getListByJno(jno: any) {
    return this.httpClient.get(this.uri + `/queryByJno/${jno}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 根据工单-报价单ID获取报价单修改轨迹列表
  getTraceByJqno(jqno: any) {
    return this.httpClient.get(this.traceUri + `/queryByJqno/${jqno}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }

  // 新增工单-报价单
  add(jobQuotation: any): Observable<any[]> {
    return this.httpClient.post(this.uri + '/add', jobQuotation).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新工单-报价单
  update(jobQuotation: any) {
    return this.httpClient.put(this.uri + '/update', jobQuotation).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新供应商
  delete(id) {
    return this.httpClient.delete(this.uri + `/delete/${id}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
}
